import {
  Button,
  Input,
  Message,
  Spinner,
  LinkText,
  Checkbox,
  Popup
} from 'common/components';
import React, { useEffect, useState } from 'react';
import { SubButtonType } from 'common/components/button';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface AddLendingUserBoardProps {
  isDisplay: boolean;
  isLendingUserProcessing: boolean;
  isLendingUserProcessingFail: boolean;
  isInvalidAddress: boolean;
  glossary: Glossary;
  onInit: () => void;
  onClickClose: () => void;
  onClickRegister: (email: string) => void;
  onClickTermsLink: () => void;
}

interface CheckBoxState {
  /** 登録条件の同意にチェックしたか否か */
  agreeTerms: boolean;
}

export const AddLendingUserBoard: React.FC<AddLendingUserBoardProps> = ({
  isDisplay,
  isLendingUserProcessing,
  isLendingUserProcessingFail,
  isInvalidAddress,
  glossary,
  onInit,
  onClickClose,
  onClickRegister,
  onClickTermsLink
}) => {
  const [emptyMessageDisp, setEmptyMessageDisp] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const inputEmail = (e: any) => {
    setEmail(e.target.value);
  };
  const initCheckedState = {
    agreeTerms: false
  };

  /**  チェック状態の定義と変更 */
  const [checkedState, setCheckedState] = React.useState<CheckBoxState>(
    initCheckedState
  );

  /** 登録条件のチェックボックス押下時の処理 */
  const onClickTermsCheckBox = () => {
    setCheckedState({ ...checkedState, agreeTerms: !checkedState.agreeTerms });
  };

  /** チェック状態によって利用登録ボタンのサブタイプを制御 */
  let subButtonType: SubButtonType = 'invalid';
  if (checkedState.agreeTerms && !isLendingUserProcessing) {
    subButtonType = 'highPriority';
  }

  useEffect(() => {
    isDisplay && onInit();
    setEmptyMessageDisp(false);
    setEmail('');
    setCheckedState(initCheckedState);
  }, [isDisplay]);

  const checkValidation = () => {
    if (email !== '') {
      setEmptyMessageDisp(false);
      onClickRegister(email);
    } else if (email === '') {
      setEmptyMessageDisp(true);
    }
  };

  const onClickDeleteProcessing = () => {
    // 削除処理中はバックグラウンドをクリックしても何もしない
  };

  const _component =
    window.innerWidth > 639 || document.documentElement.clientWidth > 639 ? (
      <Popup
        className="addLendingUserBoard-popup"
        onClickBackground={
          isLendingUserProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="addLendingUserBoard-popup"
        visible={isDisplay}
      >
        <div className="addLendingUserBoard">
          <Message type="message" data-test="addLendingUserBoard-message_1">
            {glossary.glx(BoardGL.useSettingUserOther)}
          </Message>
          {isLendingUserProcessingFail && (
            <Message
              type="message"
              data-test="addLendingUserBoard-message_2"
              className="errorMessage"
            >
              {glossary.glx(BoardGL.failedToUseSetting)}
              <br />
              {isInvalidAddress ? glossary.glx(BoardGL.notCanonID) : null}
            </Message>
          )}
          {emptyMessageDisp && (
            <Message
              type="message"
              className="errorMessage"
              data-test="addLendingUserBoard-message_3"
            >
              {glossary.glx(BoardGL.pleaseInputEmail)}
            </Message>
          )}
          <div className="inputFlex">
            <Input
              onChange={inputEmail}
              className="input"
              data-test="addLendingUserBoard-input"
              placeholder={glossary.glx(BoardGL.email)}
            />
          </div>
          <LinkText
            type="termsLink"
            data-test="addLendingUserBoard-termsLink"
            onClick={onClickTermsLink}
          >
            {glossary.glx(BoardGL.confirmCriteria)}
          </LinkText>
          <div className="termsAgreementFlex">
            <Checkbox
              id="registerTermsAgreement"
              value="termsAgreement"
              checked={checkedState.agreeTerms}
              onChange={onClickTermsCheckBox}
              data-test="addLendingUserBoard-termsCheckbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickTermsCheckBox}
              data-test="addLendingUserBoard-termsAgreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <div className="buttonFlex">
            <Button
              type="nextButton"
              subType={subButtonType}
              onClick={checkValidation}
              data-test="addLendingUserBoard-registerButton"
            >
              {isLendingUserProcessing ? (
                <Spinner type="button" width={22} height={22} />
              ) : (
                glossary.glx(BoardGL.execute)
              )}
            </Button>
            <Button
              className="cancelButton"
              type="toolButton"
              onClick={onClickClose}
              data-test="addLendingUserBoard-cancelButton"
            >
              {glossary.glx(BoardGL.cancel)}
            </Button>
          </div>
        </div>
      </Popup>
    ) : (
      <Popup
        className="addLendingUserBoard-popup"
        onClickBackground={
          isLendingUserProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="addLendingUserBoard-popup"
        visible={isDisplay}
      >
        <div className="addLendingUserBoard">
          <Message type="message" data-test="addLendingUserBoard-message_1">
            {glossary.glx(BoardGL.useSettingUserOther)}
          </Message>
          {isLendingUserProcessingFail && (
            <Message
              type="message"
              data-test="addLendingUserBoard-message_2"
              className="errorMessage"
            >
              {glossary.glx(BoardGL.failedToUseSetting)}
              <br />
              {isInvalidAddress ? glossary.glx(BoardGL.notCanonID) : null}
            </Message>
          )}
          {emptyMessageDisp && (
            <Message
              type="message"
              className="errorMessage"
              data-test="addLendingUserBoard-message_3"
            >
              {glossary.glx(BoardGL.pleaseInputEmail)}
            </Message>
          )}
          <div className="inputFlex">
            <Input
              onChange={inputEmail}
              className="input"
              data-test="addLendingUserBoard-input"
              placeholder={glossary.glx(BoardGL.email)}
            />
          </div>
          <LinkText
            type="termsLink"
            data-test="addLendingUserBoard-termsLink"
            onClick={onClickTermsLink}
          >
            {glossary.glx(BoardGL.confirmCriteria)}
          </LinkText>
          <div className="termsAgreementFlex">
            <Checkbox
              id="registerTermsAgreement"
              value="termsAgreement"
              checked={checkedState.agreeTerms}
              onChange={onClickTermsCheckBox}
              data-test="addLendingUserBoard-termsCheckbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickTermsCheckBox}
              data-test="addLendingUserBoard-termsAgreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <Button
            type="nextButton"
            subType={subButtonType}
            onClick={checkValidation}
            data-test="addLendingUserBoard-registerButton"
          >
            {isLendingUserProcessing ? (
              <Spinner type="button" width={22} height={22} />
            ) : (
              glossary.glx(BoardGL.execute)
            )}
          </Button>
          <Button
            className="cancelButton"
            type="toolButton"
            onClick={onClickClose}
            data-test="addLendingUserBoard-cancelButton"
          >
            {glossary.glx(BoardGL.cancel)}
          </Button>
        </div>
      </Popup>
    );
  return isDisplay ? _component : null;
};
